import util from '../../util'

const {Ajax, AJAX_OPTION} = util;
const apiKeyJson = {
    defaultWidget: "ACT_FLOW_DEFAULT_WIDGET",
    widgetList: "ACT_FLOW_WIDGET_LIST",
    changeSequence: "ACT_FLOW_WIDGET_SEQUENCE",
    postList: "ACT_POST_LIST",
    getCalendarEvent: "COLABO2_SCHD_R005",
    getAlarmList: "ALARM",
    getBannerList: "ACT_BANNER_LIST",
    getBannerOpen: "ACT_BANNER_OPEN",
    putProject: "ACT_FLOW_WIDGET_PROJECT",
    getProjectInfo: "ACT_PROJ_TITLE_R001",
    setBackground: "ACT_FLOW_WIDGET_BACKGROUND",
    chatList: "CHATTING",
    getProfile: "COLABO2_USER_PRFL_R002",
    getTaskList: "FLOW_TASK_R001",
    setFilter: "ACT_FLOW_WIDGET_FILTER",
    updateWidgetSize: "ACT_USER_WIDGET_UPDATE",
    getTaskCount: "ACT_TASK_SUMMR_R001",
    getTaskReport: "FLOW_TASK_REPORT_R001",
    getChatData: "COLABO2_CHAT_R001",
    setProfile: "FLOW_WIDGET_PROFILE",
    getSettingWidget: "ACT_FLOW_SETTING_WIDGET_LIST",
    AddWidget: "ACT_FLOW_WIDGET_ADD",
    deleteWidget: 'ACT_FLOW_WIDGET_DELETE',
    getFileData: "ACT_FILE_LIST",
    getStar: "FLOW_GROUP_R001",
    getStarChat: "COLABO2_CHAT_C002",
    getMealKrx: "MEAL_KRX_LIST",
    memoController: "ACT_MEMO",
    getWorkerRecommend: "ACT_WORKER_RECOMMEND",
    getCompanyUser: "COLABO2_USER_R002",
    getProjectList: "ACT_PROJECT_LIST",
    updatePrfl: "COLABO2_USER_PRFL_U002",
    insightWidget: "INSIGHT_WIDGET_R002",
}

async function getApi(apiKey, data, packetOption) {
    const ajaxSpace = new Ajax({packetOption: packetOption || AJAX_OPTION.ALLOW_EXECUTE});
    let result;
    try {
        result = await ajaxSpace.executeApi(apiKeyJson[apiKey], {...data});
        GoogleTagManager?.collect({
            ...data,
            "event": apiKey,
        })
    } catch (e) {
        console.error('ERROR in Dashboard.getApi', e);
        return {};
    }
    return result;
}

export
{
    getApi,
}
